import { render, staticRenderFns } from "./PagesMainFeatureItem.vue?vue&type=template&id=df1939c8&"
import script from "./PagesMainFeatureItem.vue?vue&type=script&lang=js&"
export * from "./PagesMainFeatureItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VCard,VInput})
